import { combineReducers } from 'redux'
import { i18nState } from 'redux-i18n'

import { dataReducer } from "./data"
import { uiReducer } from './ui'
import { metadataReducer } from "./metaData"

const rootReducer = combineReducers({
	i18nState,
	uiReducer,
	dataReducer,
	metadataReducer,
})

export default rootReducer


// WEBPACK FOOTER //
// ./src/reducers/index.js